<template>
  <div id="sidebar">
    <div v-b-visible="handleVisible" class="position-fixed d-block d-lg-none"></div>
    <div id="logo">
      <b-tooltip target="burger-menu" placement="bottom" triggers="hover">
        <span v-if="drawerStatus">Cliquez pour agrandir le menu</span>
        <span v-else>Cliquez pour réduire le menu</span>
      </b-tooltip>

      <font-awesome-icon
        id="burger-menu"
        icon="bars"
        class="menu-burger"
        @click="setDrawer(!drawerStatus)"
      ></font-awesome-icon>
    </div>

    <div class="avatar">
      <div class="container-avatar">
        <b-img
          v-if="userConnected && userConnected.picture == null"
          img
          src="../img/avatar-client.png"
          alt="user-img"
        />
        <b-img-lazy
          v-else
          img
          :src="userConnected.picture"
          alt="user-img"
          class="img-circle"
        />
      </div>
      <div class="user-info">
        <h5 class="user-name">
          {{ userConnected.lastName }} {{ userConnected.firstName }}
        </h5>
        <span class="user-mail">{{ userConnected.email }}</span>
      </div>
    </div>

    <b-tooltip
      target="tooltip-goToDossier"
      v-if="drawerStatus == true"
      placement="right"
    >
      Demandes de voirie
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToRetards"
      v-if="
        drawerStatus == true && userConnected.roles.includes('ROLE_INSTRUCTEUR')
      "
      placement="right"
    >
      Demandes en retard
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToDestinataires"
      v-if="drawerStatus == true && userConnected.roles.includes('ROLE_ADMIN')"
      placement="right"
    >
      Gestion des destinataires
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToUsers"
      v-if="drawerStatus == true && userConnected.roles.includes('ROLE_ADMIN')"
      placement="right"
    >
      Gestion des utilisateurs
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToModeles"
      v-if="drawerStatus == true && userConnected.roles.includes('ROLE_ADMIN')"
      placement="right"
    >
      Gestion des modèles
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToGrafana"
      v-if="drawerStatus == true"
      placement="right"
    >
      Tableau de bord
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToAccount"
      v-if="drawerStatus == true"
      placement="right"
    >
      Mon compte
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToCatalogue"
      v-if="drawerStatus == true"
      placement="right"
    >
      Catalogue
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToDocuments"
      v-if="drawerStatus == true"
      placement="right"
    >
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToIneris"
      v-if="drawerStatus == true"
      placement="right"
    >
      Déclaration INERIS
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToBroadcastMessage"
      v-if="drawerStatus == true"
      placement="right"
    >
      Message général
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToDisconnect"
      v-if="drawerStatus == true"
      placement="right"
    >
      Se déconnecter
    </b-tooltip>
    <div id="menu">
      <ul>
        <li id="tooltip-goToDossier">
          <router-link to="/dossiers">
            <font-awesome-icon icon="road"></font-awesome-icon>
            Demandes de voirie
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          id="tooltip-goToDestinataires"
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
        >
          <router-link to="/destinataires">
            <font-awesome-icon icon="envelope"></font-awesome-icon>
            Gestion des destinataires
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          id="tooltip-goToUsers"
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
        >
          <router-link to="/users">
            <font-awesome-icon icon="users"></font-awesome-icon>
            Gestion des utilisateurs
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          id="tooltip-goToModeles"
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
        >
          <router-link to="/modeles">
            <font-awesome-icon icon="signature"></font-awesome-icon>
            Gestion des modèles
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          id="tooltip-goToGrafana"
          @click="goToGrafana()"
          v-if="
            userConnected &&
              (userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                userConnected.roles.includes('ROLE_ADMIN'))
          "
        >
          <font-awesome-icon icon="chart-bar"></font-awesome-icon>
          Tableau de bord
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li>
        <li id="tooltip-goToAccount" v-if="userConnected.id !== 248">
          <router-link to="/account">
            <font-awesome-icon icon="user"></font-awesome-icon>
            Mon compte
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <!-- <li
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
          id="tooltip-goToHistorique"
        >
          <router-link to="/history">
            <font-awesome-icon icon="user-secret"></font-awesome-icon>
            Historique
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li> -->
        <li
          v-if="userConnected.roles.includes('ROLE_SUPER_ADMIN')"
          id="tooltip-goToBroadcastMessage"
        >
          <router-link to="/message">
            <font-awesome-icon icon="comment"></font-awesome-icon>
            Message général
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          v-if="userConnected.roles.includes('ROLE_SUPER_ADMIN')"
          id="tooltip-goToMaintenanceManagement"
        >
          <router-link to="/maintenance-management">
            <font-awesome-icon icon="tools"></font-awesome-icon>
            Mode maintenance
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li @click="logout" id="tooltip-goToDisconnect">
          <font-awesome-icon icon="door-closed"></font-awesome-icon>
          Se déconnecter
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "Sidebar",
  watch: {
    isXsSmMd: {
      handler: function(val) {
        this.setDrawer(val);
      },
    },
  },
  data() {
    return {
      isXsSmMd: false,
    };
  },

  methods: {
    goToGrafana() {
      window.open("https://grafana.clicmap.fr/d/7sZZidhGa/macs-gdpr?orgId=1");
    },
    handleVisible(isVisible) {
      this.isXsSmMd = isVisible;
    },
    ...Vuex.mapActions("Authentification", ["logout", "setDrawer"]),
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected", "drawerStatus"]),
  },
};
</script>
